import React, { Component } from 'react';
import {
    FormGroup,
    RadioButton,
    RadioButtonGroup
} from 'carbon-components-react';
import { settings } from 'carbon-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react/index';

import './radioset.scss';

const { prefix } = settings,
    helperTextClasses = classNames(`${prefix}--form__helper-text`);

@observer
export default class RadioSet extends Component {
    constructor(props) {
        super(props);
        this.warningFn = (typeof props.warning === 'function')
            ? props.warning
            : () => { return false; };
    }

    getRadio(optionValue, optionLabel, other, value, index) {
        const selected = value === optionValue;

        return (
            <RadioButton
                name={`${other.name}`}
                key={`${other.id}-${index}`}
                value={optionValue}
                labelText={optionLabel}
                disabled={other.disabled || (other.readOnly && !selected)}
            />
        );
    }

    render() {
        const {
                options,
                description,
                label,
                value,
                errors,
                showErrors,
                inline,
                warningFn,
                ...radioProps
            } = this.props,

            classes = classNames('ht-field ht-radiogroup', {
                'ht-radiogroup--vertical': !inline,
                'ht-radiogroup--horizontal': inline
            }),
            groupClasses = classNames({
                'bx--radio-button-group--vertical': !inline,
                'bx--radio-button-group--horizontal': inline
            }),

            helperText = description && description() ? description() : false,
            invalid = !!errors,
            warning = this.warningFn(value === 'single' || value === 'some' || value === 'none');

        return (
            <div className={classes}>
                <FormGroup legendText={label}>
                    {helperText && (
                        <div className={helperTextClasses}>{helperText}</div>
                    )}
                    <RadioButtonGroup
                        className={groupClasses}
                        defaultSelected={value}
                        valueSelected={value}
                        {...radioProps}
                    >
                        {options().map(
                            ({ value: optionValue, label: optionLabel }, index) => this.getRadio(optionValue, optionLabel, radioProps, value, index)
                        )}
                    </RadioButtonGroup>
                </FormGroup>
                {warning && <p className='ht-field-warning'>{warning}</p>}
                {showErrors && invalid && errors && (
                    <div
                        className='bx--form-requirement'
                        id={`${radioProps.name}-error-msg`}
                    >
                        {errors}
                    </div>
                )}
            </div>
        );
    }
}

RadioSet.defaultProps = {
    errors: '',
    inline: false,
    showErrors: true,
    description: () => {}
};

RadioSet.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    errors: PropTypes.string,
    inline: PropTypes.bool,
    showErrors: PropTypes.bool,
    description: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    options: PropTypes.func.isRequired
};
